export const remote = process.env.REACT_APP_REMOTE_HOST;
export const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY;
